// extracted by mini-css-extract-plugin
export default {"BreadcrumbContainer":"Impressum_BreadcrumbContainer__f3shM"};